var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "45px",
    viewBox: "0 0 32 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-12.3%",
    y: "-33.7%",
    width: "124.7%",
    height: "167.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AddNewEvent",
    transform: "translate(-515, -670)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(517, 671)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#979797",
    strokeWidth: 1.1,
    fill: "#B0B0B0",
    opacity: 0.858189174,
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter-1)",
    cx: 14,
    cy: 36.5475113,
    rx: 11.6078947,
    ry: 3.90248869
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C21.35,0 28,5.67506787 28,14.4520362 C28,20.3033484 23.3275,27.2297511 14,35.2488688 C4.6725,27.2297511 0,20.3033484 0,14.4520362 C0,5.67506787 6.65,0 14,0 Z",
    id: "Path",
    stroke: "#FFFFFF",
    fill: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,14.4520362 C24.5,8.05436652 19.8625,3.52488688 14,3.52488688 C8.1375,3.52488688 3.5,8.05436652 3.5,14.4520362 C3.5,18.5761538 6.9125,24.0397285 14,30.5607692 C21.0875,24.0397285 24.5,18.5761538 24.5,14.4520362 Z",
    id: "Path",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,19.6651584 C10.9605263,19.6651584 8.47368421,17.1606335 8.47368421,14.0995475 C8.47368421,11.0384615 10.9605263,8.53393665 14,8.53393665 C17.0394737,8.53393665 19.5263158,11.0384615 19.5263158,14.0995475 C19.5263158,17.1606335 17.0394737,19.6651584 14,19.6651584 Z",
    id: "Path",
    fill: "#FF4300"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/MapPin.9c9ed9c00d70256824d4e3a5e52b942d.svg";
export { ForwardRef as ReactComponent };